import styles from '../../assets/css/accounts.module.css';
import { useSelector } from 'react-redux';
import { selectPrimaryColor, selectSecondaryColor } from '../../app/slices/configuration.slice';

interface IndicatorCircleProps {
	isActive?: boolean;
}

const IndicatorCircle = ({ isActive = false }: IndicatorCircleProps) => {
	const primaryColor = useSelector(selectPrimaryColor) as string;
	const secondaryColor = useSelector(selectSecondaryColor) as string;

	const innerActiveCircleStyles: React.CSSProperties = {
		width: '10px',
		height: '10px',
		borderRadius: '999px',
		background: primaryColor,
		zIndex: 2
	};

	const activeCircleStyle: React.CSSProperties = {
		background: secondaryColor,
		border: 'none',
		zIndex: 1
	};
	return (
		<div
			className={`${styles['account-select-circle']} ${isActive && styles['active-circle']}`}
			style={activeCircleStyle}
		>
			<div className={styles['account-indicator-circle']}>
				{isActive && <div className={styles['inner-active-circle']} style={innerActiveCircleStyles}></div>}
			</div>
		</div>
	);
};

export default IndicatorCircle;
